import { Component } from "@angular/core";

@Component({
    selector: "lg-excel-export-dialog",
    template: `
        <div class="lg-excel-export-dialog__status-row">
            {{ _state }}
        </div>
        <div
            class="lg-excel-export-dialog__progress-row"
            [style.marginTop.px]="16"
            [style.marginBottom.px]="24"
        >
            <lg-progress-bar [progress]="_progress"></lg-progress-bar>
        </div>
    `,
    host: { class: "lg-excel-export-dialog" }
})
export class LgExcelExportDialogComponent {
    set state(value: string) {
        this._state = value;
    }

    get state(): string {
        return this._state;
    }

    set progress(value: number) {
        this._progress = value;
    }

    get progress(): number {
        return this._progress;
    }

    _state = "Berekenen";
    _progress = 0;
}
